import React, { useEffect, useState } from "react";
import { Menu, X, Instagram } from "lucide-react";
import { LOGO_URL, INSTAGRAM_URL } from "../data/site";

const LINKS = [
    { href: "#chi-siamo", label: "Chi Siamo" },
    { href: "#servizi", label: "Servizi" },
    { href: "#pacchetti", label: "Pacchetti" },
    { href: "#metodo", label: "Metodo" },
    { href: "#team", label: "Team" },
    { href: "#app", label: "App" },
    { href: "#contatti", label: "Contatti" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-ink/85 backdrop-blur-xl border-b border-gold/20"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="container mx-auto px-4 sm:px-6 lg:px-10">
                <div className="flex items-center justify-between h-16 sm:h-20">
                    <a
                        href="#top"
                        data-testid="header-logo-link"
                        className="flex items-center gap-3 group"
                    >
                        <img
                            src={LOGO_URL}
                            alt="RPF Coaching"
                            className="h-10 sm:h-12 w-10 sm:w-12 object-cover rounded-md ring-1 ring-gold/30 group-hover:ring-gold transition"
                        />
                        <div className="hidden sm:block leading-tight">
                            <div className="font-oswald font-bold tracking-widest text-white text-lg">
                                RPF
                            </div>
                            <div className="font-oswald text-[11px] tracking-[0.35em] text-gold">
                                COACHING
                            </div>
                        </div>
                    </a>

                    <nav
                        className="hidden xl:flex items-center gap-7"
                        data-testid="header-desktop-nav"
                    >
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="relative font-manrope text-sm uppercase tracking-[0.15em] text-zinc-300 hover:text-white transition-colors
                                after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-gold after:transition-all
                                hover:after:w-full"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>

                    <div className="hidden xl:flex items-center gap-3">
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="header-instagram"
                            aria-label="Instagram RPF"
                            className="w-10 h-10 rounded-full border border-gold/40 flex items-center justify-center text-gold hover:bg-gold hover:text-ink transition-colors"
                        >
                            <Instagram size={16} />
                        </a>
                        <a
                            href="#contatti"
                            data-testid="header-cta-button"
                            className="inline-flex items-center gap-2 bg-gold text-ink font-oswald font-bold uppercase tracking-wider px-6 py-3 rounded hover:bg-gold-bright hover:shadow-[0_0_24px_rgba(212,175,55,0.45)] transition-all"
                        >
                            Inizia Ora
                        </a>
                    </div>

                    <button
                        data-testid="mobile-menu-toggle"
                        aria-label="Apri menu"
                        onClick={() => setOpen((v) => !v)}
                        className="xl:hidden text-white p-2 -mr-2"
                    >
                        {open ? <X size={26} /> : <Menu size={26} />}
                    </button>
                </div>
            </div>

            {/* mobile menu */}
            <div
                data-testid="mobile-menu"
                className={`xl:hidden overflow-hidden transition-[max-height,opacity] duration-500 ${
                    open ? "max-h-[640px] opacity-100" : "max-h-0 opacity-0"
                } bg-ink/95 backdrop-blur-xl border-t border-gold/15`}
            >
                <nav className="container mx-auto px-6 py-6 flex flex-col gap-3">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="font-oswald uppercase tracking-[0.2em] text-white py-2 border-b border-white/5 hover:text-gold transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                    <div className="flex gap-3 mt-3">
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="mobile-instagram"
                            className="flex-1 inline-flex items-center justify-center gap-2 border border-gold/40 text-gold py-3 rounded font-oswald uppercase tracking-wider text-sm"
                        >
                            <Instagram size={16} /> Instagram
                        </a>
                        <a
                            href="#contatti"
                            onClick={() => setOpen(false)}
                            data-testid="mobile-cta-button"
                            className="flex-1 bg-gold text-ink font-oswald font-bold uppercase tracking-wider text-center py-3 rounded text-sm"
                        >
                            Inizia Ora
                        </a>
                    </div>
                </nav>
            </div>
        </header>
    );
}
